<template>
  <div>
    <v-card-text style="height: 532px; overflow-y: auto;">
      <v-layout row wrap v-if="setting">
        <v-flex xs6 pr-1>
          <v-text-field :value="id" label="ID" readonly></v-text-field>
          <v-text-field v-model="setting.name" label="Name" :readonly="id" persistent-hint hint="Name cannot be edited after creation."></v-text-field>
          <v-text-field v-model="setting.title" label="Title"></v-text-field>
<!--          <v-text-field v-model="setting.type" label="Type"></v-text-field>-->
          <v-autocomplete
            :items="settingTypes"
            v-model="setting.type"
            label="Type"
            item-text="label"
            item-value="value">
          </v-autocomplete>

          <v-select
            :items="notifiers"
            v-model="setting.value.module"
            label="Module"
            item-text="name"
            item-value="value"
            v-if="setting.type == 'external_notifier'">
          </v-select>

        </v-flex>
        <v-flex xs6 pl-1>
          <template v-if="setting.type == 'external_notifier' && setting.value">
            <div class="mt-1">Form</div>
            <form-editor v-model="setting.value.form" :height="230"></form-editor>
            <template v-if="setting.value.module == 'EPG'">
              <v-tooltip bottom v-model="show_template_tooltip">
                <template template v-slot:activator="{ on }">
                  <div class="mt-1">Template <span @click="show_template_tooltip = !show_template_tooltip" style="cursor: pointer;" class="primary--text">?</span></div>
                </template>
                <div>
                  <h4>Help</h4>
                  Format time (<a href="https://man7.org/linux/man-pages/man3/strftime.3.html" target="_blank">strftime manual</a>):<br>
                  <code>{{ '\{\{#format_time\}\}\{"format": "[strftime format]", "timestamp": \{\{timestamp\}\}\}\{\{/format_time\}\}' }}</code><br>
                  Loop events:<br>
                  <code>{{ '\{\{#events\}\}\{\{/events\}\}'}}</code>
                </div>
              </v-tooltip>

              <CodeEditor v-model="setting.value.template" lang="xml" height="220px" />
            </template>
          </template>
          <template v-else>
            <json-editor v-model="setting.value" v-if="setting.value"></json-editor>
          </template>
        </v-flex>
      </v-layout>

    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="reset">Reset</v-btn>
      <v-btn color="success" @click="save(false)">Save</v-btn>
      <v-btn color="success" @click="save(true)">Save and close</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import JsonEditor from '@/components/JsonEditor'
import CodeEditor from '@/components/CodeEditor';
import FormEditor from '@/components/FormEditor';
import SettingsModel from '@/models/settings.js'
import ExternalModel from '@/models/external.js'

export default {
  props: ['id'],
  components: {
    JsonEditor,
    CodeEditor,
    FormEditor
  },
  data() {
    var ch = this.$cloudserver.channel("settings:"+(this.id||"create"));
    return {
      ws_channel: ch,
      setting: this.convertSetting(ch.data),
      settingTypes: SettingsModel.types(),
      show_template_tooltip: false
    };
  },
  watch: {
    'ws_channel.data': {
      handler(newVal, oldVal) {
        this.setting = this.convertSetting(newVal, oldVal);
      },
      deep: true
    },
		'$route' (to, from) {
			if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
				this.ws_channel = this.$cloudserver.channel("settings:"+(this.id||"create"));
				this.ws_channel.join();
			}
		}
  },
  created() {
    this.ws_channel.join();
  },
  computed: {
    notifiers() {
      return ExternalModel.notifiers;
    }
  },
  methods: {
    convertSetting (newVal, oldVal) {
      var setting = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }

      if(typeof(setting) == "undefined" || _.isEmpty(setting)) return undefined;
      return setting;
    },
    reset() {
      this.setting = this.convertSetting(this.ws_channel.data);
    },
    save (close) {
      var self = this;
      if (typeof(this.ws_channel) != "undefined") {
      	var setting = _.cloneDeep(this.setting);
        this.ws_channel.save({setting: setting})
          .then((msg) => {
            if (typeof(self.id) == "undefined") {
              self.$message.success("Setting was created!");
            } else {
              self.$message.success("Setting was updated!");
            }
            if(close) {
              self.$root.close_bottom_sheet();
            } else if(typeof(self.id) == "undefined" && typeof(this.$route.meta.edit) != "undefined") {
              this.$router.push({name: this.$route.meta.edit, params: {id: msg.data.id}})
            }          })
          .catch((msg) => {
            console.log(msg);
            if (typeof(self.id) == "undefined") {
              self.$message.warning("Unable to create setting!");
            } else {
              self.$message.warning("Unable to update setting!");
            }
          });
      }
    }
  }
}
</script>
